<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start pt-4 pt-sm-0 pt-md-4 px-2 px-lg-0 pl-lg-4 pl-xl-4>
      <v-flex xs12>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs7 sm3 md3 lg2 xl2>
            <v-layout wrap justify-center>
              <v-flex xs3 sm2 text-left align-self-center>
                <v-img
                  src="./../../../assets/Images/agogo.png"
                  contain
                  height="30px"
                ></v-img>
              </v-flex>
              <v-flex xs9 sm10 text-left pl-2 align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                 Orders
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      justify-start
      pt-4
      px-2
      pl-xl-4
      v-for="(item, i) in orders"
      :key="i"
    >
      <!-- <v-flex xs12 text-left pb-4 pl-2>
        <span
          style="font-family: opensansbold; font-size: 20px; color: #808080"
        >
          {{ formatDate(item.orderdate) }}
        </span>
      </v-flex> -->
      <v-flex
        xs12
        sm6
        md6
        lg4
        xl4
        text-start
       
        pa-2
      >
        <SoldProductItem v-bind:storage="item" />
      </v-flex>
      <v-flex xs12 py-2>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="orders.length < 1">
      <v-flex xs12>
        <span
          style="font-family: poppinsregular; font-size: 25px; color: #000000"
        >
          Oops! No Products Found
        </span>
      </v-flex>
      
    </v-layout>
  </div>

</template>
<script>
import axios from "axios";
import SoldProductItem from "./soldProductItem";
export default {
  components: {
    SoldProductItem,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
       getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "seller/ordered/products/list",
        headers: {
         token: localStorage.getItem("token"),
        },
        data:{
          productOrderStatus:'delivered',
          page: 1,
          limit:10,
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
          this.orders = response.data.data;
           
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError =true;
          console.log(err);
        });
    },

    getData1() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/purchase/sellerpurchasedata",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          deliverystatus: ["Delivered", "Return"],
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.orders = response.data.data;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>
// v-for="(transaction, i) in item.transactions"
        :key="i"